import React from 'react';

const BotAvatar = () => {
  return (
    <div className="ri-botavata">
      <img src="/img/icon_chatbot.png" />
    </div>
  );
};

export default BotAvatar;
